import * as React from "react";
import { HangTagOutline } from "components/icons/hang-tag-outline";
import { formatMessage } from "lib/globalize-util";

export const AllBrands: React.FunctionComponent<{}> = () => {
    return (
        <div className="brandPageHeader">
            <HangTagOutline />
            <div className="brandHeaderText">{formatMessage("Select a brand to start shopping")}</div>
        </div>
    );
};
